import i18n from "i18next";

import translationEn from "./language/en/translation.json";
import translationzh_CN from "./language/zh_CN/translation.json";
import translationNl from "./language/nl/translation.json";

i18n
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    },

    resources: {
      en: {
        translations: translationEn
      },
      zh_CN:{
        translations: translationzh_CN
      },
      nl:{
        translations: translationNl
      }
    },
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations"
  });

export default i18n;
